// extracted by mini-css-extract-plugin
export default {"dList":"PR5U09z3orMT68gvXED7"};